/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactListRequestContactList,
  CreateContactListRequestContactListFromJSON,
  CreateContactListRequestContactListFromJSONTyped,
  CreateContactListRequestContactListToJSON
} from './CreateContactListRequestContactList'

/**
 *
 * @export
 * @interface CreateContactListRequest
 */
export interface CreateContactListRequest {
  /**
   *
   * @type {CreateContactListRequestContactList}
   * @memberof CreateContactListRequest
   */
  contactList?: CreateContactListRequestContactList
}

export function CreateContactListRequestFromJSON(json: any): CreateContactListRequest {
  return CreateContactListRequestFromJSONTyped(json, false)
}

export function CreateContactListRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateContactListRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactList: !exists(json, 'contact_list')
      ? undefined
      : CreateContactListRequestContactListFromJSON(json['contact_list'])
  }
}

export function CreateContactListRequestToJSON(value?: CreateContactListRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_list: CreateContactListRequestContactListToJSON(value.contactList)
  }
}
